import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { CreatePentestConfigData } from '../models';
import { ScanConfig } from '../models/scan-config';
import { GetPentestConfigData } from '../models/get-pentest-config.data';
import { DemoStore } from '../stores';
import { DemoDataService } from './demo-data.service';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly httpClient = inject(HttpClient);
  private readonly demoStore = inject(DemoStore);
  private readonly demoDataService = inject(DemoDataService);

  createScanConfig(
    customerId: number | undefined,
    createPentestConfigData: CreatePentestConfigData,
  ): Observable<GetPentestConfigData> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getGetPentestConfigData());
    }
    return this.httpClient.post<GetPentestConfigData>(
      `/api/customers/${customerId || 'me'}/configs`,
      createPentestConfigData,
    );
  }

  getScanConfig(customerId: number | undefined, configId: string): Observable<GetPentestConfigData> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getGetPentestConfigData(configId));
    }
    return this.httpClient.get<GetPentestConfigData>(`/api/customers/${customerId || 'me'}/configs/${configId}`);
  }

  updateScanConfig(
    customerId: number | undefined,
    configId: string,
    createPentestConfigData: CreatePentestConfigData,
  ): Observable<GetPentestConfigData> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getGetPentestConfigData(configId));
    }
    return this.httpClient.put<GetPentestConfigData>(
      `/api/customers/${customerId || 'me'}/configs/${configId}`,
      createPentestConfigData,
    );
  }
  deleteScanConfig(customerId: number | undefined, configId: string): Observable<void> {
    if (this.demoStore.isDemoMode()) {
      return of();
    }
    return this.httpClient.delete<any>(`/api/customers/${customerId || 'me'}/configs/${configId}`);
  }
  performScanConfigAction(customerId: number | undefined, configId: string, action: string): Observable<void> {
    if (this.demoStore.isDemoMode()) {
      return of();
    }
    return this.httpClient.post<any>(`/api/customers/${customerId || 'me'}/configs/${configId}/${action}`, null);
  }

  getScanConfigurations(customerId: number | undefined): Observable<ScanConfig[]> {
    if (this.demoStore.isDemoMode()) {
      return of(this.demoDataService.getScanConfigurations());
    }
    return this.httpClient.get<any>(`/api/customers/${customerId || 'me'}/configs`);
  }
}
